import React from 'react';
import Introduction from './components/Introduction';
import Post from './components/Post'
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet'
import './index.css';
import './Top.css';
import './Layout.css';
import PostDate from './Article/Posts/Posts.json'
import ScrollToTop from "./components/ScrollToTop";

export default class Top extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <Helmet>
                    <title>{this.props.siteName}</title>
                </Helmet>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ delay: 0.25, ease: "easeIn" }}
                >
                    <Introduction siteName={this.props.siteName} />

                    {Object.keys(PostDate).map((posts) => {
                        return <Post PostDate={PostDate[posts]} />
                    })}

                </motion.div>
            </>
        )
    }
};


